import { useContext } from 'react'
import GlobalContext from '../../context/global-context'

// Material-ui
import Backdrop from '@mui/material/Backdrop'
//import CircularProgress from '@mui/material/CircularProgress'
//import Typography from '@mui/material/Typography'

const Loader = () => {
  const { ui } = useContext(GlobalContext)

  return (
    <div>
      {ui.loader.visible && (
        <div>
          <Backdrop sx={{ zIndex: 1600 }} open={true}>
            <div className="bg-gray-200 bg-opacity-50 rounded-lg p-6 flex items-center justify-center shadow-lg">
          <div className="loader-spinner border-4 border-t-accent2 border-gray-200 rounded-full w-16 h-16 animate-spin"></div>
        </div>
          </Backdrop>
        </div>
      )}
    </div>
  )

  /*return (
    <div>
      {ui.loader.visible && (
        <div>
          <Backdrop sx={{ zIndex: 1600 }} open={true}>
            <div className='py-6 px-12 flex flex-col items-center justify-center bg-white'>
              <Typography variant='h6' className='text-xl mb-4 text-center'>
                {ui.loader.text || 'Cargando'}
              </Typography>
              <CircularProgress color='primary' thickness={5} size={60} />
            </div>
          </Backdrop>
        </div>
      )}
    </div>
  )*/
}

export default Loader
